import { round, isNumber, isString } from 'lodash'
import {TimeUnit, DistanceUnit} from '@eventops/athlinks-results-model'

export type Without<T, U> = { [P in Exclude<keyof T, keyof U>]?: never }
export type XOR<T, U> =
  (T | U) extends object ? (Without<T, U> & U) |
  (Without<U, T> & T) : T | U

export interface DisplayData<T extends string | number> {
  value: T,
  label: string
}

export type Precision = number | DistanceUnit | TimeUnit

export enum LabelVerbosity {
  SHORT = 'short',
  STANDARD = 'standard',
  LONG = 'long'
}

export enum LabelPlurality {
  SINGULAR = 'singular',
  PLURAL = 'plural'
}

export interface LabelPluralityMap {
  singular: string,
  plural: string
}

export interface LabelMap {
  short: LabelPluralityMap,
  standard: LabelPluralityMap,
  long?: LabelPluralityMap
}

export interface UnitMap {
  [x: string]: () => LabelMap
}

export enum UnitLength {
  SHORT = 'short',
  STANDARD = 'standard',
  LONG = 'long'
}

export interface BasicConversionArgs {
  verbosity?: LabelVerbosity,
  capitalize?: boolean
}

export function isPlural(value: number): boolean {
  const magnitude = Math.abs(value)
  return magnitude === 0 || magnitude > 1
}

export function makePrecise(
  value: number,
  precsion?: Precision,
  unitType?: DistanceUnit | TimeUnit
) {
  if (isNumber(precsion)) {
    return round(value, precsion)
  }
  if (isString(precsion) && unitType === precsion) {
    return round(value, 0)
  }
  return value
}
